import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpMethods } from '@cbre/http';
import { LookupRefService } from '@shared/services/lookup-ref.service';
import { forkJoin, Observable, Subject, timer } from 'rxjs';
import { map } from 'rxjs/operators';

const tagsBaseUrl = '/search/tags?entity=';
const bulkChangeUrl = '/clipboard/bulkUserTag';

@Injectable()
export class ChangeTagsService extends HttpMethods {
  private filterTagsUrl = '';
  private notifyNext: Subject<boolean> = new Subject();
  private _entity: string = '';

  public entityIds: number[] = [];
  public get entity() {
    return this._entity;
  }
  public set entity(currentEntity: string) {
    this._entity = currentEntity;
  }
  public recordsWithErrors: number[] = [];
  public notificationToNext: Observable<boolean> = this.notifyNext.asObservable();

  constructor(
    httpClient: HttpClient,
    private lookupService: LookupRefService
  ) {
    super(httpClient);
  }

  public setParams(entity: string, entitiesIds: number[]) {
    this.entity = entity;
    this.entityIds = entitiesIds || [];
    this.filterTagsUrl = tagsBaseUrl + entity;
  }

  public executeAddTags(tags: string[]) {
    const userTags = tags.map(tag => ({ name: tag }));
    const data = { entity: this.entity, entityIds: this.entityIds, action: 'add', userTags };
    this.executeAction(data);
  }

  public executeRemoveTags(tagIds: string[]) {
    const userTags = tagIds.map(tagId => ({ name: tagId }));
    const data = { entity: this.entity, entityIds: this.entityIds, action: 'delete', userTags };
    this.executeAction(data);
  }

  public executeUpdateTags(tagIdsToRemove: string[], tagsToAdd: string[]) {
    const userTags = tagsToAdd.map(tag => ({ name: tag }));
    const userTagsToDelete = tagIdsToRemove.map(tagId => ({ name: tagId }));
    const data = {
      entity: this.entity,
      entityIds: this.entityIds,
      action: 'update',
      userTags,
      userTagsToDelete,
    };
    this.executeAction(data);
  }

  public getPossibleTagsToDelete(): Observable<Array<{ key: string; value: string }>> {
    return this.httpPost(this.filterTagsUrl, this.entityIds);
  }

  public onFilterTags(param: string): Observable<string[]> {
    const url = `${this.filterTagsUrl}&query=${param}`;
    return this.lookupService.loadDataFor(url, true, true).pipe(
      map(t => {
        return t.map(x => x.value);
      })
    );
  }

  private executeAction(data: any) {
    this.notifyNext.next(true);
    setTimeout(() => {
      forkJoin([this.httpPut(bulkChangeUrl, data), timer(3000)])
        .pipe(map(([response, _]) => (response == null ? [] : response)))
        .subscribe(
          response => {
            this.recordsWithErrors = response;
            this.notifyNext.next(true);
          },
          _error => {
            this.notifyNext.next(false);
          }
        );
    }, 0);
  }
}
